
export default {
  props: {
    product: {
      default: () => {},
    },
  },
  computed: {
    url() {
      if (!process.server) return location.origin + this.$route.fullPath
      return ''
    },
  },
}
